/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_Roles_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to create new roles and edit or delete roles lower than their highest role. Also allows members to change permissions of individual channels t..." |
*
* @param {Leveling_Perm_Manage_Roles_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_roles_hint = /** @type {((inputs?: Leveling_Perm_Manage_Roles_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_Roles_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам создавать роли, а также изменять и удалять роли ниже своей наивысшей роли. Кроме того, участники смогут менять права отдельных каналов, к которым у них есть доступ.")
	return /** @type {LocalizedString} */ ("Allows members to create new roles and edit or delete roles lower than their highest role. Also allows members to change permissions of individual channels that they have access to.")
});